import React, { useState, useEffect } from "react";
import { Search, X } from "lucide-react";
import { useDebounce } from "../../hooks/common/useDebounce";

interface SearchBarProps {
  onSearch: (query: string) => void;
  onClear: () => void;
  placeholder?: string;
  isLoading?: boolean;
  className?: string;
}

const SearchBar = ({
  onSearch,
  onClear,
  placeholder = "에이전트를 검색해보세요...",
  isLoading = false,
  className = "",
}: SearchBarProps) => {
  const [query, setQuery] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const debouncedQuery = useDebounce(query, 1000);

  useEffect(() => {
    if (debouncedQuery.trim()) {
      onSearch(debouncedQuery);
    } else if (debouncedQuery === "") {
      onClear();
    }
  }, [debouncedQuery, onSearch, onClear]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
  };

  const handleClear = () => {
    setQuery("");
    onClear();
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch(query.trim());
    }
  };

  return (
    <form onSubmit={handleSubmit} className={`relative ${className}`}>
      <div
        className={`
          relative flex items-center bg-white rounded-full border-2 transition-all duration-200
          ${isFocused ? "border-teal-500 shadow-lg" : "border-gray-200 hover:border-gray-300"}
        `}
      >
        <div className="flex items-center justify-center w-12 h-12 text-gray-400">
          {isLoading ? (
            <div className="animate-spin rounded-full h-5 w-5 border-2 border-teal-500 border-t-transparent" />
          ) : (
            <Search className="w-5 h-5" />
          )}
        </div>
        
        <input
          type="text"
          value={query}
          onChange={handleInputChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder={placeholder}
          className="flex-1 px-2 py-3 text-gray-700 bg-transparent border-none outline-none placeholder-gray-400 font-serif-kr"
        />
        
        {query && (
          <button
            type="button"
            onClick={handleClear}
            className="flex items-center justify-center w-12 h-12 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        )}
      </div>
      
      {/* 검색 제안 또는 최근 검색어 표시 영역 (향후 확장용) */}
      {/* {isFocused && query && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          검색 제안 목록이 들어갈 자리
        </div>
      )} */}
    </form>
  );
};

export default SearchBar; 